import React from 'react';
import PropTypes from 'prop-types';

export default function Fortel({ twilioNumber }) {
  return (
    <div>
      <ul>
        <li>Call the service provider at 1-800-959-6621</li>
        <li>
          Once you reach a service rep, please tell them that you want to set-up
          &quot;Call forwarding - No answer&quot; and &quot;Call forwarding - Busy line&quot;
          on your business phone number to your new {twilioNumber}
        </li>
      </ul>
    </div>
  );
}

Fortel.defaultProps = {
  twilioNumber: '',
};

Fortel.propTypes = {
  twilioNumber: PropTypes.string,
};
